import React from 'react';
import InputField from '../../../components/CustomFields/InputField';

const ParentDetails = ({ student, handleChange }) => {
    return (
        <section className="">
            <h2 className="text-lg font-semibold text-[#824296] text-center">Parent Details</h2>
            {student.parentList?.map((parent, idx) => {
                // Determine parent type label (Mother, Father, Guardian, etc.)
                const parentType = parent.type 
                    ? parent.type.charAt(0) + parent.type.slice(1).toLowerCase()
                    : "Parent";
                
                return (
                    <div key={idx} className="space-y-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {/* First Name */}
                            <InputField
                                id={`parentFirstName-${idx}`}
                                label={`${parentType} First Name *`}
                                value={parent.firstName}
                                onChange={(e) => handleChange(`parentList[${idx}].firstName`, e.target.value)}
                            />

                            {/* Last Name */}
                            <InputField
                                id={`parentLastName-${idx}`}
                                label={`${parentType} Last Name *`}
                                value={parent.lastName}
                                onChange={(e) => handleChange(`parentList[${idx}].lastName`, e.target.value)}
                            />
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {/* Email */}
                            <InputField
                                id={`parentEmail-${idx}`}
                                label={`${parentType} Email *`}
                                value={parent.email}
                                onChange={(e) => handleChange(`parentList[${idx}].email`, e.target.value)}
                                type="email"
                            />

                            {/* Phone Number */}
                            <InputField
                                id={`parentPhoneNumber-${idx}`}
                                label={`${parentType} Phone Number *`}
                                value={parent.phoneNumber}
                                onChange={(e) => handleChange(`parentList[${idx}].phoneNumber`, e.target.value)}
                            />
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                            {/* Occupation */}
                            <InputField
                                id={`parentOccupation-${idx}`}
                                label={`${parentType} Occupation *`}
                                value={parent.occupation}
                                onChange={(e) => handleChange(`parentList[${idx}].occupation`, e.target.value)}
                            />

                            {/* Annual Income */}
                            <InputField
                                id={`parentIncome-${idx}`}
                                label={`${parentType} Annual Income *`}
                                value={parent.annualIncome}
                                onChange={(e) => handleChange(`parentList[${idx}].annualIncome`, e.target.value)}
                            />
                        </div>
                    </div>
                );
            })}
        </section>
    );
};

export default ParentDetails;